/** API route map: URLS.Controller.GarnishmentCategory */
export const GarnishmentCategory = {
      Name: 'GarnishmentCategory/',
      GetGarnishmentCategory: 'get',
      AddGarnishmentCategory: 'add',
      UpdateGarnishmentCategory: 'update',
      DeleteGarnishmentCategory: 'delete',
};
